import platformEnv from"../platformEnv";export const headerPlatform=[platformEnv.appPlatform,platformEnv.appChannel].filter(Boolean).join('-');